import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useAdminGuard } from '../hooks/useAdminGuard';
import AdminStats from '../components/admin/AdminStats';
import AdminPoolRounds from '../components/admin/AdminPoolRounds';
import AdminUserLookup from '../components/admin/AdminUserLookup';
import AdminMissingPool from '../components/admin/AdminMissingPool';
import AdminUserOps from '../components/admin/AdminUserOps';
import AdminSystem from '../components/admin/AdminSystem';
import AdminEmergency from '../components/admin/AdminEmergency';
import AdminWiring from '../components/admin/AdminWiring';
import AdminOwnership from '../components/admin/AdminOwnership';
import WalletModal from '../components/wallet/WalletModal';

const Admin = () => {
  const { account } = useWallet();
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey((k) => k + 1);
  const guard = useAdminGuard(refreshKey);
  const [open, setOpen] = useState(false);

  if (!account) {
    return (
      <Layout dashboard>
        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
          <h2 className="text-yellow">Admin Panel</h2>
          <p className="text-muted" style={{ marginTop: 8 }}>Connect a wallet with admin or owner privileges.</p>
          <button className="btn btn-primary btn-lg" style={{ marginTop: 18 }} onClick={() => setOpen(true)}>Connect Wallet</button>
          <WalletModal open={open} onClose={() => setOpen(false)} />
        </div>
      </Layout>
    );
  }

  if (guard.loaded && !guard.canAccess) return <Navigate to="/dashboard" replace />;

  if (!guard.loaded) {
    return (
      <Layout dashboard>
        <div className="page-header">
          <div className="page-title">Admin</div>
          <div className="page-subtitle">Verifying privileges…</div>
        </div>
        <div className="card"><div className="empty">Loading…</div></div>
      </Layout>
    );
  }

  return (
    <Layout dashboard>
      <div className="page-header">
        <div className="page-title">Admin Panel</div>
        <div className="page-subtitle">
          Connected as <span style={{ color: 'var(--bnb-yellow)', textTransform: 'uppercase', fontWeight: 700 }}>{guard.role}</span>
          {guard.role === 'owner' && ' — full privileges'}
          {guard.role === 'admin' && ' — operational privileges'}
        </div>
      </div>

      <div className="admin-grid">
        <AdminStats        role={guard.role} refreshKey={refreshKey} />
        <AdminPoolRounds   role={guard.role} refreshKey={refreshKey} onChanged={refresh} />
        <AdminUserLookup   role={guard.role} />
        <AdminMissingPool  role={guard.role} onChanged={refresh} />
        <AdminUserOps      role={guard.role} onChanged={refresh} />
        <AdminSystem       role={guard.role} refreshKey={refreshKey} onChanged={refresh} />
        <AdminEmergency    role={guard.role} refreshKey={refreshKey} onChanged={refresh} />
        <AdminWiring       role={guard.role} onChanged={refresh} />
        <AdminOwnership    role={guard.role} details={guard.details} onChanged={refresh} />
      </div>
    </Layout>
  );
};

export default Admin;
